import React from 'react';
import Reveal from './Reveal';

export default function SectionHeader({ eyebrow, title, lede, align = 'split' }) {
  if (align === 'center') {
    return (
      <div style={{ textAlign: 'center', marginBottom: 64, maxWidth: 720, marginInline: 'auto' }}>
        {eyebrow && <Reveal><span className="eyebrow"><span className="dot" />{eyebrow}</span></Reveal>}
        {title && <Reveal delay={0.06} as="h2" style={{ marginTop: 18 }}>{title}</Reveal>}
        {lede && <Reveal delay={0.12}><p className="lede" style={{ marginTop: 18, marginInline: 'auto' }}>{lede}</p></Reveal>}
      </div>
    );
  }
  return (
    <div className="section-head">
      <div>
        {eyebrow && <Reveal><span className="eyebrow"><span className="dot" />{eyebrow}</span></Reveal>}
        {title && <Reveal delay={0.06} as="h2" style={{ marginTop: 18 }}>{title}</Reveal>}
      </div>
      {lede && <Reveal delay={0.12}><p className="lede">{lede}</p></Reveal>}
    </div>
  );
}
